// extracted by mini-css-extract-plugin
module.exports = {"Section":"PushSection_Section__1OKLV","Action":"PushSection_Action__KqpbR"};